<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="tongue-and-groove">
<h1>Tongue And Groove</h1>
<p style="text-align: center;">the Idea was</p>
<p style="text-align: center;">to fill your father’s desk with poem after poem of the flesh made Word</p>
<p style="text-align: center;">whether anyone bought it or not</p><br/>
<p style="text-align: center;">but i couldn’t fulfill half my promise</p>
<p style="text-align: center;">cooped up in a smoky room with too many distractions and one Small wonder</p><br/>
<p style="text-align: center;">all i could do</p>
<p style="text-align: center;">was weigh down the deep drawer with reams of recycled</p>
<p style="text-align: center;">re-envisioned nights</p>
<p style="text-align: center;">that cracked the tongue and groove</p><br/>
<p style="text-align: center;">the point is (sorry) not that the deep drawer</p>
<p style="text-align: center;">doesn’t close right (a bit askew like me)</p>
<p style="text-align: center;">and sticks when it slides</p><br/>
<p style="text-align: center;">just let it be</p>
<p style="text-align: center;">your father’s desk drawer full of the slow struggles of the troubled son</p>
<p style="text-align: center;">he never had</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?68f91de0